import React from "react"
import styled from "styled-components"
import { normalizeExerciseId } from "../../util/strings"

const Heading = styled.div`
  & h2 {
    font-family: "Josefin Sans", sans-serif;
    font-weight: 500;
    font-size: clamp(28px, 4vw, 40px);
    line-height: 1.8rem;
    color: #333;
  }
`

const H2 = ({ children }) => {
  let text = "unknown heading"
  try {
    text = children.find((o) => typeof o === "string") || "unknown heading"
  } catch (e) {}
  const id = `heading-${normalizeExerciseId(text)}`
  return (
    <Heading>
      <h2 className="material-header" id={id}>
        {" "}
        {children}{" "}
      </h2>{" "}
    </Heading>
  )
}

export default H2
